import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { SaasService } from '../../Service/saas-service';
import { ToastService } from '../../Service/toast-service';

@Component({
  selector: 'app-saas-company-edit',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule],
  templateUrl: './saas-company-edit.html',
  styleUrl: './saas-company-edit.css'
})
export class SaasCompanyEdit implements OnInit {
  editForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SaasCompanyEdit>,
    @Inject(MAT_DIALOG_DATA) public data: any, // Cacha el payload robusto original
    private saasService: SaasService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    console.log('>>> [EDIT COCKPIT] Cargando parámetros avanzados para el Tenant:', this.data.coId);
    
    this.editForm = this.fb.group({
      // Candados físicos de infraestructura contable
      coId: [{ value: this.data.coId, disabled: true }], 
      ccco: [{ value: this.data.ccco, disabled: true }], 
      mcuBu: [{ value: this.data.mcuBu, disabled: true }],
      crdc: [{ value: this.data.crdc, disabled: true }],
      adminAn8: [{ value: this.data.adminAn8 || 10000001, disabled: true }],
      
      // 🏢 Datos de la Compañía Editables
      nameAlpha: [this.data.nameAlpha, [Validators.required, Validators.maxLength(255)]],
      taxId: [this.data.taxId, [Validators.required, Validators.maxLength(50)]],
      ownerName: [this.data.ownerName, [Validators.required, Validators.maxLength(255)]],
      email: [this.data.email || '', [Validators.required, Validators.email]],
      supportPhone: [this.data.supportPhone, [Validators.required, Validators.maxLength(50)]],
      enabled: [this.data.enabled],

      // 🎛️ Credenciales del Administrador Local (Opcionales en Edición)
      adminUser: [this.data.adminUser || '', [Validators.required, Validators.maxLength(50)]],
      adminPassword: ['', [Validators.minLength(6)]], // 💡 Opcional: Si se deja vacío, Java no la machaca

      // ⚖️ Controles de Conformidad Jurídica PROFECO
      tipoTaller: [this.data.tipoTaller || 'AMBOS', Validators.required],                  
      numRegContAdhesion: [this.data.numRegContAdhesion || '0', [Validators.required, Validators.maxLength(100)]], 
      tallerCuentaSeguro: [this.data.tallerCuentaSeguro || 'NO', Validators.required],               
 
      // 📍 Campos Geográficos de Ubicación
      calleNumero: [this.data.calleNumero || '', [Validators.required, Validators.maxLength(255)]],
      colonia: [this.data.colonia || '', [Validators.required, Validators.maxLength(255)]],
      codigoPostal: [this.data.codigoPostal || '', [Validators.required, Validators.pattern('^[0-9]{5}$')]], 
      delegacionMunicipio: [this.data.delegacionMunicipio || '', [Validators.required, Validators.maxLength(255)]],
      estado: [this.data.estado || '', [Validators.required, Validators.maxLength(255)]]
    });
  }

  onSubmit(): void {
    if (this.editForm.invalid) {
      this.editForm.markAllAsTouched();
      this.toastService.showDanger('Formulario Inválido', 'Por favor, corrija los campos mandatorios marcados en rojo.');
      return;
    }

    const formRaw = this.editForm.getRawValue();

    // Armamos el DTO robusto sanitizado en mayúsculas
    const payloadActualizacion: any = {
      ...this.data, 
      nameAlpha: formRaw.nameAlpha.trim().toUpperCase(),
      taxId: formRaw.taxId.trim().toUpperCase(),
      ownerName: formRaw.ownerName.trim().toUpperCase(),
      supportPhone: formRaw.supportPhone.trim(),
      enabled: formRaw.enabled,
      
      email: (formRaw.email || '').trim().toUpperCase(), 

      // Credenciales
      adminUser: formRaw.adminUser.trim().toLowerCase(),
      adminPassword: formRaw.adminPassword ? formRaw.adminPassword.trim() : '', // Viaja vacío si no cambia

      // Profeco
      tipoTaller: formRaw.tipoTaller.trim().toUpperCase(),
      numRegContAdhesion: formRaw.numRegContAdhesion.trim().toUpperCase(),
      tallerCuentaSeguro: formRaw.tallerCuentaSeguro.trim().toUpperCase(),

      // Dirección
      calleNumero: formRaw.calleNumero.trim().toUpperCase(),
      colonia: formRaw.colonia.trim().toUpperCase(),
      codigoPostal: formRaw.codigoPostal.trim(),
      delegacionMunicipio: formRaw.delegacionMunicipio.trim().toUpperCase(),
      estado: formRaw.estado.trim().toUpperCase()
    };

    console.log('Despachando reestructuración total de Tenant a Spring Boot:', payloadActualizacion);

    this.saasService.actualizarDatosCompania(this.data.coId, payloadActualizacion).subscribe({
      next: (res) => {
        const objetoUICompleto = {
          ...res,
          ownerName: payloadActualizacion.ownerName,
          supportPhone: payloadActualizacion.supportPhone,
          // Conservamos el resto de variables mapeadas en el grid local
          tipoTaller: payloadActualizacion.tipoTaller,
          numRegContAdhesion: payloadActualizacion.numRegContAdhesion,
          tallerCuentaSeguro: payloadActualizacion.tallerCuentaSeguro,
          calleNumero: payloadActualizacion.calleNumero,
          colonia: payloadActualizacion.colonia,
          codigoPostal: payloadActualizacion.codigoPostal,
          delegacionMunicipio: payloadActualizacion.delegacionMunicipio,
          estado: payloadActualizacion.estado
        };
        this.dialogRef.close(objetoUICompleto);
      },
      error: (err) => {
        console.error('Error fatal de reestructuración SaaS:', err);
        this.toastService.showDanger(
          'Fallo de Actualización',
          err.error?.error || 'No se pudieron salvar los cambios en el servidor.'
        );
        this.cdr.detectChanges();
      }
    });
  }
}